import type { DevMenuTone } from "../Menu/DevMenuPrimitives";

interface EnvironmentBadgeProps {
  environment: string;
  isLocalOverride?: boolean | undefined;
  tone?: DevMenuTone | undefined;
}

const TONE_CLASSES: Record<
  DevMenuTone,
  { container: string; label: string; value: string }
> = {
  hubble: {
    container: "bg-card border-b-2 border-border px-3 py-2",
    label: "text-xs font-bold tracking-wider text-content-muted uppercase",
    value: "mt-0.5 text-xs font-semibold text-content-secondary",
  },
  cargo: {
    container: "bg-card border-b border-border px-8 py-3",
    label: "text-xs font-bold tracking-wider text-content-muted uppercase",
    value: "mt-0.5 text-sm font-semibold text-content-secondary",
  },
};

/**
 * Read-only badge surfacing the current API environment. When a local
 * override is active (e.g. `VITE_LOCAL_OVERRIDE_ENVIRONMENT=demo`) the
 * environment name is suffixed with "(override)" in orange so it's obvious
 * the running app isn't talking to its native backend.
 */
export function EnvironmentBadge({
  environment,
  isLocalOverride,
  tone = "hubble",
}: EnvironmentBadgeProps) {
  const classes = TONE_CLASSES[tone];
  return (
    <div className={classes.container}>
      <div className={classes.label}>API Environment</div>
      <div className={classes.value}>
        {environment}
        {isLocalOverride && (
          <span className="ml-1 text-xs font-normal text-orange">
            (override)
          </span>
        )}
      </div>
    </div>
  );
}
